import { render, staticRenderFns } from "./CustomQuestionCard.vue?vue&type=template&id=4d868e64&scoped=true"
import script from "./CustomQuestionCard.vue?vue&type=script&lang=ts"
export * from "./CustomQuestionCard.vue?vue&type=script&lang=ts"
import style0 from "./CustomQuestionCard.vue?vue&type=style&index=0&id=4d868e64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d868e64",
  null
  
)

export default component.exports